// import { Report55Component } from "../../../components/SupportSystem/Reports/Report55Component";
import { ListReportSupportSubmitRequestComponent } from "../../../components/SupportSystem/Reports/ListReportSupportSubmitRequestComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
// import { NavbarComponent } from "../../../components/share/NavbarComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function ListReportSupportSubmitRequestContainer() {
    const titleName = "แบบบันทึกข้อมูลจัดสรรเงิน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem  />
            <HeadTitle title={titleName} />
            <ListReportSupportSubmitRequestComponent/>
            <Footer />
        </div>   
        // 
    )
    
}